import classNames from 'classnames';
import * as React from 'react';
import type { VimeoId } from '~/Blocks/VimeoVideoBlock/VimeoId.csharp';
import type { QueryParameter } from '~/Partials/SearchBase/QueryParameterUtils';
import { formatQueryParameters } from '~/Partials/SearchBase/QueryParameterUtils';
import { isNonEmptyString } from '~/Partials/Utils/typeUtils';
import styles from './Vimeo.module.css';

export interface VimeoProps {
    videoId: VimeoId;
    title: string;
    autoplay?: boolean;
    className?: string;
}

export const Vimeo: React.FC<VimeoProps> = props => {
    const { videoId, title, autoplay, className } = props;
    const parameters: QueryParameter[] = React.useMemo(() => {
        const params: QueryParameter[] = [];

        if (autoplay) {
            params.push({ name: 'autoplay', value: '1' });
        }

        if (isNonEmptyString(videoId.privacyHash)) {
            params.push({ name: 'h', value: videoId.privacyHash });
        }

        return params;
    }, [autoplay, videoId.privacyHash]);

    return (
        <div className={classNames(styles.Vimeo, className)}>
            <iframe
                loading="lazy"
                title={title}
                src={`https://player.vimeo.com/video/${videoId.id}${formatQueryParameters(parameters)}`}
                width="640"
                height="480"
                allow="autoplay; fullscreen"
                data-ready="true"
            />
        </div>
    );
};
